export const ConfigBuilderAbi = [
  {
    type: 'constructor',
    inputs: [
      { name: '_governance', type: 'address', internalType: 'address' },
      { name: '_messenger', type: 'address', internalType: 'address' },
      { name: '_priceOracleDeployer', type: 'address', internalType: 'address' },
      { name: '_index', type: 'address', internalType: 'address' },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'chainRebalancingFinished',
    inputs: [
      { name: 'chainId', type: 'uint256', internalType: 'uint256' },
      { name: 'resultHash', type: 'bytes32', internalType: 'bytes32' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'configHash',
    inputs: [],
    outputs: [{ name: '', type: 'bytes32', internalType: 'bytes32' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'configs',
    inputs: [
      {
        name: 'config',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.Config',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.SharedConfig',
            components: [
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'depositFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          {
            name: 'redemptionFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
    ],
    outputs: [
      {
        name: 'deposit',
        type: 'tuple',
        internalType: 'struct IIndex.DepositConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
      {
        name: 'redemption',
        type: 'tuple',
        internalType: 'struct IIndex.RedemptionConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          { name: 'forwarder', type: 'address', internalType: 'address' },
          { name: 'homeCurrencies', type: 'uint256[]', internalType: 'a160u96[]' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'currenciesUpdated',
    inputs: [
      {
        name: 'result',
        type: 'tuple',
        internalType: 'struct ICurrencyMetadata.RegisteredMetadata',
        components: [
          { name: 'chainId', type: 'uint256', internalType: 'uint256' },
          {
            name: 'metadata',
            type: 'tuple[]',
            internalType: 'struct ICurrencyMetadata.CurrencyMetadata[]',
            components: [
              { name: 'name', type: 'string', internalType: 'string' },
              { name: 'symbol', type: 'string', internalType: 'string' },
              { name: 'decimals', type: 'uint8', internalType: 'uint8' },
              { name: 'currency', type: 'address', internalType: 'Currency' },
            ],
          },
          { name: 'currenciesHash', type: 'bytes32', internalType: 'bytes32' },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'finishRebalancing',
    inputs: [
      {
        name: 'results',
        type: 'tuple[]',
        internalType: 'struct IVault.RebalancingResult[]',
        components: [
          { name: 'chainId', type: 'uint256', internalType: 'uint256' },
          { name: 'snapshot', type: 'uint256', internalType: 'uint256' },
          { name: 'currencyIdSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencies', type: 'uint256[]', internalType: 'a160u96[]' },
        ],
      },
      {
        name: 'config',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.Config',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.SharedConfig',
            components: [
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'depositFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          {
            name: 'redemptionFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
    ],
    outputs: [
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IIndex.DepositConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
      {
        name: '',
        type: 'tuple',
        internalType: 'struct IIndex.RedemptionConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          { name: 'forwarder', type: 'address', internalType: 'address' },
          { name: 'homeCurrencies', type: 'uint256[]', internalType: 'a160u96[]' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'getState',
    inputs: [],
    outputs: [
      {
        name: 'state',
        type: 'tuple',
        internalType: 'struct IConfigMigration.State',
        components: [
          { name: 'pendingChainCount', type: 'uint8', internalType: 'uint8' },
          { name: 'snapshotChainIndexSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'weights', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'activeChainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainsHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'configHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'anatomyHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
          { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
          { name: 'homeCurrencies', type: 'uint256[]', internalType: 'a160u96[]' },
          {
            name: 'chainStates',
            type: 'tuple[]',
            internalType: 'struct IConfigMigration.ChainState[]',
            components: [
              { name: 'currenciesHash', type: 'bytes32', internalType: 'bytes32' },
              { name: 'resultHash', type: 'bytes32', internalType: 'bytes32' },
            ],
          },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'governance',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'index',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'messenger',
    inputs: [],
    outputs: [{ name: '', type: 'address', internalType: 'address' }],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'previewStartRebalancing',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.StartRebalancingParams',
        components: [
          {
            name: 'anatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          {
            name: 'newAnatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencies', type: 'address[][]', internalType: 'Currency[][]' },
          { name: 'newWeights', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'orderCounts', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'payload', type: 'bytes', internalType: 'bytes' },
        ],
      },
    ],
    outputs: [
      {
        name: 'result',
        type: 'tuple',
        internalType: 'struct RebalancingLib.RebalancingResult',
        components: [
          {
            name: 'chainOrders',
            type: 'tuple[]',
            internalType: 'struct RebalancingLib.ChainOrders[]',
            components: [
              {
                name: 'orders',
                type: 'tuple[]',
                internalType: 'struct OrderLib.Order[]',
                components: [
                  { name: 'sellAmount', type: 'uint96', internalType: 'uint96' },
                  {
                    name: 'idParams',
                    type: 'tuple',
                    internalType: 'struct OrderLib.OrderId',
                    components: [
                      { name: 'sellCurrency', type: 'address', internalType: 'Currency' },
                      { name: 'localBuyCurrency', type: 'address', internalType: 'Currency' },
                      {
                        name: 'finalDestinationBuyCurrency',
                        type: 'address',
                        internalType: 'Currency',
                      },
                      { name: 'finalDestinationChainId', type: 'uint256', internalType: 'uint256' },
                    ],
                  },
                ],
              },
              { name: 'incomingOrders', type: 'uint128', internalType: 'uint128' },
            ],
          },
          {
            name: 'withdrawals',
            type: 'tuple[]',
            internalType: 'struct IVault.CurrencyWithdrawal[]',
            components: [
              { name: 'currencyIndexSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'amounts', type: 'uint96[]', internalType: 'uint96[]' },
            ],
          },
          { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'counters', type: 'uint256[]', internalType: 'uint256[]' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'previewStartReserveRebalancing',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.StartReserveRebalancingParams',
        components: [
          {
            name: 'anatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencies', type: 'address[][]', internalType: 'Currency[][]' },
        ],
      },
    ],
    outputs: [
      {
        name: 'orders',
        type: 'tuple[]',
        internalType: 'struct RebalancingLib.ChainOrders[]',
        components: [
          {
            name: 'orders',
            type: 'tuple[]',
            internalType: 'struct OrderLib.Order[]',
            components: [
              { name: 'sellAmount', type: 'uint96', internalType: 'uint96' },
              {
                name: 'idParams',
                type: 'tuple',
                internalType: 'struct OrderLib.OrderId',
                components: [
                  { name: 'sellCurrency', type: 'address', internalType: 'Currency' },
                  { name: 'localBuyCurrency', type: 'address', internalType: 'Currency' },
                  {
                    name: 'finalDestinationBuyCurrency',
                    type: 'address',
                    internalType: 'Currency',
                  },
                  { name: 'finalDestinationChainId', type: 'uint256', internalType: 'uint256' },
                ],
              },
            ],
          },
          { name: 'incomingOrders', type: 'uint128', internalType: 'uint128' },
        ],
      },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    name: 'registerChain',
    inputs: [{ name: 'chainId', type: 'uint256', internalType: 'uint256' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setConfig',
    inputs: [
      {
        name: '_config',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.Config',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.SharedConfig',
            components: [
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'depositFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          {
            name: 'redemptionFee',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
    ],
    outputs: [
      {
        name: 'deposit',
        type: 'tuple',
        internalType: 'struct IIndex.DepositConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
        ],
      },
      {
        name: 'redemption',
        type: 'tuple',
        internalType: 'struct IIndex.RedemptionConfig',
        components: [
          {
            name: 'shared',
            type: 'tuple',
            internalType: 'struct IIndex.Config',
            components: [
              { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
              { name: 'AUMDilutionPerSecond', type: 'uint256', internalType: 'uint256' },
              { name: 'useCustomAUMFee', type: 'bool', internalType: 'bool' },
              { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
              { name: 'metadata', type: 'address', internalType: 'address' },
            ],
          },
          {
            name: 'fee',
            type: 'tuple',
            internalType: 'struct IIndex.FeeConfig',
            components: [
              { name: 'BPs', type: 'uint16', internalType: 'uint16' },
              { name: 'useCustomCallback', type: 'bool', internalType: 'bool' },
            ],
          },
          { name: 'forwarder', type: 'address', internalType: 'address' },
          { name: 'homeCurrencies', type: 'uint256[]', internalType: 'a160u96[]' },
        ],
      },
    ],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setMessenger',
    inputs: [{ name: '_messenger', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setPriceOracleDeployer',
    inputs: [{ name: '_priceOracleDeployer', type: 'address', internalType: 'address' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'setState',
    inputs: [
      {
        name: 'state',
        type: 'tuple',
        internalType: 'struct IConfigMigration.State',
        components: [
          { name: 'pendingChainCount', type: 'uint8', internalType: 'uint8' },
          { name: 'snapshotChainIndexSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'weights', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'activeChainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'chainsHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'configHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'anatomyHash', type: 'bytes32', internalType: 'bytes32' },
          { name: 'latestSnapshot', type: 'uint256', internalType: 'uint256' },
          { name: 'staticPriceOracle', type: 'address', internalType: 'address' },
          { name: 'homeCurrencies', type: 'uint256[]', internalType: 'a160u96[]' },
          {
            name: 'chainStates',
            type: 'tuple[]',
            internalType: 'struct IConfigMigration.ChainState[]',
            components: [
              { name: 'currenciesHash', type: 'bytes32', internalType: 'bytes32' },
              { name: 'resultHash', type: 'bytes32', internalType: 'bytes32' },
            ],
          },
        ],
      },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'startRebalancing',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.StartRebalancingParams',
        components: [
          {
            name: 'anatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          {
            name: 'newAnatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencies', type: 'address[][]', internalType: 'Currency[][]' },
          { name: 'newWeights', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'orderCounts', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'payload', type: 'bytes', internalType: 'bytes' },
        ],
      },
      { name: 'data', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'function',
    name: 'startReserveRebalancing',
    inputs: [
      {
        name: 'params',
        type: 'tuple',
        internalType: 'struct IConfigBuilder.StartReserveRebalancingParams',
        components: [
          {
            name: 'anatomy',
            type: 'tuple',
            internalType: 'struct IConfigBuilder.Anatomy',
            components: [
              { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
              { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
            ],
          },
          { name: 'chainIds', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencies', type: 'address[][]', internalType: 'Currency[][]' },
        ],
      },
      { name: 'data', type: 'bytes', internalType: 'bytes' },
    ],
    outputs: [],
    stateMutability: 'payable',
  },
  {
    type: 'event',
    name: 'ConfigUpdated',
    inputs: [{ name: 'encodedConfig', type: 'bytes', indexed: false, internalType: 'bytes' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'CurrenciesUpdate',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'currenciesHash', type: 'bytes32', indexed: false, internalType: 'bytes32' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'CurrencyRegistered',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'currency', type: 'address', indexed: false, internalType: 'Currency' },
      { name: 'name', type: 'string', indexed: false, internalType: 'string' },
      { name: 'symbol', type: 'string', indexed: false, internalType: 'string' },
      { name: 'decimals', type: 'uint8', indexed: false, internalType: 'uint8' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FinishChainRebalancing',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'snapshot', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'currencyIdSet', type: 'uint256[]', indexed: false, internalType: 'uint256[]' },
      { name: 'currencies', type: 'uint256[]', indexed: false, internalType: 'a160u96[]' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'FinishRebalancing',
    inputs: [
      { name: 'snapshot', type: 'uint256', indexed: false, internalType: 'uint256' },
      {
        name: 'newAnatomy',
        type: 'tuple',
        indexed: false,
        internalType: 'struct IConfigBuilder.Anatomy',
        components: [
          { name: 'chainIdSet', type: 'uint256[]', internalType: 'uint256[]' },
          { name: 'currencyIdSets', type: 'uint256[][]', internalType: 'uint256[][]' },
        ],
      },
      { name: 'weights', type: 'uint256[]', indexed: false, internalType: 'uint256[]' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'ReceiveChainResult',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'chainIndex', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'resultHash', type: 'bytes32', indexed: false, internalType: 'bytes32' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RegisterChain',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      { name: 'chainIndex', type: 'uint256', indexed: false, internalType: 'uint256' },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'RemoteChainOrders',
    inputs: [
      { name: 'chainId', type: 'uint256', indexed: false, internalType: 'uint256' },
      {
        name: 'orders',
        type: 'tuple',
        indexed: false,
        internalType: 'struct RebalancingLib.ChainOrders',
        components: [
          {
            name: 'orders',
            type: 'tuple[]',
            internalType: 'struct OrderLib.Order[]',
            components: [
              { name: 'sellAmount', type: 'uint96', internalType: 'uint96' },
              {
                name: 'idParams',
                type: 'tuple',
                internalType: 'struct OrderLib.OrderId',
                components: [
                  { name: 'sellCurrency', type: 'address', internalType: 'Currency' },
                  { name: 'localBuyCurrency', type: 'address', internalType: 'Currency' },
                  {
                    name: 'finalDestinationBuyCurrency',
                    type: 'address',
                    internalType: 'Currency',
                  },
                  { name: 'finalDestinationChainId', type: 'uint256', internalType: 'uint256' },
                ],
              },
            ],
          },
          { name: 'incomingOrders', type: 'uint128', internalType: 'uint128' },
        ],
      },
    ],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'SetMessenger',
    inputs: [{ name: 'messenger', type: 'address', indexed: false, internalType: 'address' }],
    anonymous: false,
  },
  {
    type: 'event',
    name: 'StartRebalancing',
    inputs: [
      { name: 'pendingChainIdSet', type: 'uint256[]', indexed: false, internalType: 'uint256[]' },
    ],
    anonymous: false,
  },
  {
    type: 'error',
    name: 'AlreadyRegistered',
    inputs: [{ name: 'chainId', type: 'uint256', internalType: 'uint256' }],
  },
  { type: 'error', name: 'AnatomyHash', inputs: [] },
  { type: 'error', name: 'ChainLimitReached', inputs: [] },
  { type: 'error', name: 'ChainsHashMismatch', inputs: [] },
  { type: 'error', name: 'ConfigHash', inputs: [] },
  {
    type: 'error',
    name: 'CurrenciesHashMismatch',
    inputs: [{ name: 'chainId', type: 'uint256', internalType: 'uint256' }],
  },
  { type: 'error', name: 'Forbidden', inputs: [] },
  { type: 'error', name: 'Invalid', inputs: [] },
  { type: 'error', name: 'NotRegistered', inputs: [] },
  { type: 'error', name: 'OrderLength', inputs: [] },
  {
    type: 'error',
    name: 'PendingChains',
    inputs: [{ name: '', type: 'uint256', internalType: 'uint256' }],
  },
  { type: 'error', name: 'ReserveMissed', inputs: [] },
  { type: 'error', name: 'ResultHash', inputs: [] },
  { type: 'error', name: 'TotalWeight', inputs: [] },
  { type: 'error', name: 'UnutilizedWeights', inputs: [] },
] as const
